module.exports = __webpack_public_path__ + "img/camera.4319fc51.svg";